export default __webpack_public_path__ + "static/media/dms-header-logo.1842d006.svg";